import {
  Capacitor,
  registerPlugin,
  type PluginListenerHandle,
} from '@capacitor/core'

export type NativeFloatIslandAction =
  | 'home'
  | 'projects'
  | 'explore'
  | 'settings'
  | 'new'
  | 'login'

interface NativeFloatIslandState {
  active: NativeFloatIslandAction
  visible: boolean
  icons?: Record<string, string>
  loginVisible?: boolean
  loginPlacement?: {
    centerX: number
    centerY: number
    maxWidth: number
  }
  labels: {
    home: string
    projects: string
    explore: string
    settings: string
    new: string
    login: string
    navigation: string
  }
}

interface NativeFloatIslandPlugin {
  show(options: NativeFloatIslandState): Promise<void>
  update(options: NativeFloatIslandState): Promise<void>
  hide(): Promise<void>
  addListener(
    eventName: 'action',
    listener: (event: { action: NativeFloatIslandAction }) => void,
  ): Promise<PluginListenerHandle>
}

const NativeFloatIsland = registerPlugin<NativeFloatIslandPlugin>(
  'NativeFloatIsland',
)

export const supportsNativeFloatIsland = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios'

export { NativeFloatIsland }
